import { useSelector } from 'react-redux';
import { StoreState } from '../store';

export const useUserAccess = () => {
  const accessLevel = useSelector(
    (state: StoreState) => state.user.user?.accessLevel,
  );
  const extension = useSelector((state: StoreState) => state.client.extension);
  const phones = useSelector((state: StoreState) => state.contacts.phones);
  const linkedUser = useSelector(
    (state: StoreState) => state.client.linkedUser,
  );

  const allowedAccessLevels = ['EXTENSION', 'CUSTOMER'];

  const isRegularUser = allowedAccessLevels.includes(accessLevel || '');

  const availableExtensions = phones.filter(
    (p) => p.webRTCEnabled && !p.readOnly,
  );

  const hasWebRTCEnabledExtensions = availableExtensions.length > 0;

  const extensionNotWebRTCEnabled = extension && !extension.webRTCEnabled;

  return {
    isRegularUser,
    accessLevel,
    linkedUserAccessLevel: linkedUser?.accessLevel,
    hasWebRTCEnabledExtensions,
    extensionNotWebRTCEnabled,
    availableExtensions,
  };
};
